import { Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute } from '@angular/router';
import { map } from 'rxjs';
export interface EditorialContent {
  eyebrow: string;
  title: string;
  paragraphs: string[];
}

@Component({
  selector: 'app-editorial',
  templateUrl: './editorial.component.html'
})
export class EditorialComponent {
  readonly page = toSignal(
    inject(ActivatedRoute).data.pipe(map((data) => data['page'] as EditorialContent)),
    { requireSync: true }
  );
}
